module.exports = __webpack_public_path__ + "static/media/logo.4f1f0b48.JPG";